export const SortableSlides = {
  mounted() {
    this.initSortable();
  },

  updated() {
    this.initSortable();
  },

  initSortable() {
    const container = this.el;
    if (!container) return;

    // Remove any existing sortable instance
    if (this.sortable) {
      this.sortable.destroy();
    }

    // Check if Sortable library is available
    if (typeof Sortable === 'undefined') {
      console.warn('Sortable library not found. Please include SortableJS.');
      return;
    }

    this.sortable = new Sortable(container, {
      animation: 150,
      ghostClass: 'opacity-50',
      chosenClass: 'ring-2 ring-violet-500',
      dragClass: 'rotate-3 shadow-xl',
      
      onEnd: (evt) => {
        const postId = container.dataset.postId;
        const oldIndex = evt.oldIndex;
        const newIndex = evt.newIndex;

        if (oldIndex !== newIndex) {
          this.pushEvent('reorder', {
            post_id: postId,
            old: oldIndex,
            new: newIndex
          });
        }
      }
    });
  },

  destroyed() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }
};